import moment from "moment";
import { LuInfo } from "react-icons/lu";
import Tooltip from "../Tooltip/Tooltip";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

const ContentListing = ({
  contentLibrary,
  customerScope,
  controllerCodeValue,
  hostname,
  selectedOption,
}) => {
  const scope = (customerScope || "").toLowerCase();
  const option = (selectedOption || "").toLowerCase();
  const resolveUrl = (pattern) => {
    if (!pattern) return "";
    const host = hostname || "";
    const controller = controllerCodeValue || "";
    const customer_scope = scope || "";
    const lang = option || "";

    let url = String(pattern)
      .replaceAll(/#host#/gi, `https://${host}`)
      .replaceAll(/#controller#/gi, controller)
      .replaceAll(/#customer_scope#/gi, customer_scope)
      .replaceAll(/#lang#/gi, lang);

    url = url.replaceAll(/([^:/])\/\/+/g, "$1/");
    try {
      const parsed = new URL(url, `https://${host}`);
      const isAllowedProtocol =
        parsed.protocol === "https:" || parsed.protocol === "http:";
      return isAllowedProtocol ? parsed.toString() : "";
    } catch {
      return "";
    }
  };
  return (
    <>
      {contentLibrary?.length > 0 ? (
        contentLibrary?.map((content) => (
          <section
            className="contentlibrary__content py-4"
            key={crypto.randomUUID()}
          >
            <h4 className="contentlibrary__content-title pb-4 m-0">
              {content.Document_Report} ({content.Local_Report})
            </h4>
            <div className="contentlibrary__content-lists">
              <div className="contentlibrary__lists-header row border-bottom py-2">
                <div className="col-sm-2">
                  <h6>Global Name</h6>
                </div>
                <div className="col-sm-2">
                  <h6>Local Name</h6>
                </div>

                <div className="col-sm-1">
                  <h6>Version</h6>
                </div>
                <div className="col-sm-2">
                  <h6>Effective Date</h6>
                </div>
                <div className="col-sm-2">
                  <h6>Major Change Version</h6>
                </div>
                <div className="col-sm-3">
                  <h6>Major Change Effective Date</h6>
                </div>
              </div>
              <div className="contentlibrary__lists-content">
                {content?.list?.map((list) => (
                  <a
                    href={resolveUrl(list.URL_Pattern)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none"
                    key={crypto.randomUUID()}
                  >
                    <div className="contentlibrary__container row py-3">
                      <div className="col-sm-2">
                        <p>{list?.Global_Name}</p>
                      </div>
                      <div className="col-sm-2">
                        <p>{list?.Local_Name}</p>
                      </div>
                      <div className="col-sm-1">
                        <p>{list?.version || ""}</p>
                      </div>
                      <div className="col-sm-2">
                        <p className="d-flex align-items-center">
                          {list?.effectiveDate ? (
                            <>
                              {" "}
                              <span className="pe-1">
                                {moment
                                  .utc(list?.effectiveDate)
                                  .local()
                                  .format("DD.MM.YYYY HH:mm")}
                              </span>
                              <Tooltip
                                position="left"
                                text={`${moment
                                  .utc(list?.effectiveDate)
                                  .format("DD.MM.YYYY HH:mm")} UTC`}
                                type="content-library"
                              >
                                <LuInfo
                                  className="table__date__icon"
                                  size={19}
                                />
                              </Tooltip>
                            </>
                          ) : (
                            ""
                          )}
                        </p>
                      </div>
                      <div className="col-sm-2">
                        <p>{list?.majorVersionNumber || ""}</p>
                      </div>
                      <div className="col-sm-3">
                        <p className="d-flex align-items-center">
                          {list?.majorChangeEffectiveDateTime ? (
                            <>
                              <span className="pe-1">
                                {moment
                                  .utc(list?.majorChangeEffectiveDateTime)
                                  .local()
                                  .format("DD.MM.YYYY HH:mm")}
                              </span>
                              <Tooltip
                                position="right"
                                text={`${moment
                                  .utc(list?.majorChangeEffectiveDateTime)
                                  .format("DD.MM.YYYY HH:mm")} UTC`}
                                type="content-library"
                              >
                                <LuInfo
                                  className="table__date__icon"
                                  size={19}
                                />
                              </Tooltip>
                            </>
                          ) : (
                            ""
                          )}
                        </p>
                      </div>
                    </div>
                   </a>
                ))}
              </div>
            </div>
          </section>
        ))
      ) : (
        <div className="no-data-container">
          <FormattedMessage
            id="id.table.no-data"
            defaultMessage="Data is not available"
          />
        </div>
      )}
    </>
  );
};
ContentListing.propTypes = {
  contentLibrary: PropTypes.array,
  customerScope: PropTypes.string,
  controllerCodeValue: PropTypes.string,
  hostname: PropTypes.string,
  selectedOption: PropTypes.any,
};

export default ContentListing;
